import { render, staticRenderFns } from "./defendDialog.vue?vue&type=template&id=48094a66&scoped=true&"
import script from "./defendDialog.vue?vue&type=script&lang=js&"
export * from "./defendDialog.vue?vue&type=script&lang=js&"
import style0 from "./defendDialog.vue?vue&type=style&index=0&id=48094a66&lang=less&scoped=true&"
import style1 from "./defendDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48094a66",
  null
  
)

export default component.exports